class CartVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const select = event.target;
    const oldVariantId = select.dataset.variantId;
    const newVariantId = select.value;
    const quantity = parseInt(select.dataset.quantity);
    const cartItems = this.closest('cart-drawer-items');
    
    if (cartItems && newVariantId && oldVariantId !== newVariantId) {
      this.enableLoading();

      // First add the new variant
      fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          id: newVariantId,
          quantity: quantity
        })
      })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.errors) {
          this.updateLiveRegions(parsedState.errors);
          throw new Error(parsedState.errors);
        }
        // Then remove the old variant
        return fetch(`${routes.cart_change_url}`, {
          ...fetchConfig(),
          body: JSON.stringify({
            id: oldVariantId,
            quantity: 0
          })
        });
      })
      .then((response) => response.text())
      .then(() => {
        // Refresh the entire cart drawer (reload the section)
        return fetch(`${routes.cart_url}?section_id=cart-drawer`);
      })
      .then((response) => response.text())
      .then((responseText) => {
        // Replace the entire cart drawer
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newDrawer = html.querySelector('cart-drawer');
        const currentDrawer = document.querySelector('cart-drawer');
        if (newDrawer && currentDrawer) {
          currentDrawer.replaceWith(newDrawer);
        }
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading();
      });
    }
  }

  enableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const loadingSpinners = document.querySelectorAll('.loading__spinner');
    loadingSpinners.forEach((overlay) => overlay.classList.remove('hidden'));
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const loadingSpinners = document.querySelectorAll('.loading__spinner');
    loadingSpinners.forEach((overlay) => overlay.classList.add('hidden'));
  }

  updateLiveRegions(message) {
    const lineItemStatus = document.getElementById('CartDrawer-LineItemStatus');
    if (lineItemStatus) lineItemStatus.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errors) {
      errors.textContent = message;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

// Add this function to refresh the cart drawer content after a quantity change
function refreshCartDrawer() {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newDrawer = html.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.replaceWith(newDrawer);
      }
    });
}

// Usage example: call refreshCartDrawer() after a quantity change

function fetchConfig(type = 'POST') {
  return {
    method: type,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };
}

customElements.define('cart-variant-selector', CartVariantSelector);